document.addEventListener('DOMContentLoaded', function () {
    const relatedProductsSection = document.getElementById('js-relatedProductsSection');

    if (!relatedProductsSection || !document.getElementById('js-relatedProducts')) {
        // Not a page that hosts the widget - this file is in every cobrand bundle so it runs
        // everywhere - or the server deliberately withheld the container for bot/prerender
        // traffic (ProductPage.ShowRelatedProducts). Either way, issue no Recommend request.
        return;
    }

    const cbpidValue = document.querySelector('input[name="cbpid"]')?.value ?? null;
    if (!cbpidValue) {
        // No CoBrandProductId on the page (e.g. non-product context) - nothing to look up related items for.
        relatedProductsSection?.classList.add('d-none');
        return;
    }

    const indexName = document.getElementById('js-aisIndexName')?.value;
    if (!indexName) {
        // Cobrand has no AlgoliaIndex configured (CoBrandOptions.AlgoliaIndex) - no index to
        // query against, so don't fall back to a hardcoded index and don't show the section.
        relatedProductsSection?.classList.add('d-none');
        return;
    }

    // The algoliasearch@5 lite UMD build exposes its client under
    // window["algoliasearch/lite"].liteClient, not a global `algoliasearch`
    // function (see wwwroot/js/algolia-search-custom.js for the same pattern).
    const { liteClient: algoliasearch } = window["algoliasearch/lite"];
    const searchClient = algoliasearch(window.algoliaConfig.appId, window.algoliaConfig.searchKey);

    const search = instantsearch({
        indexName,
        searchClient,
    });

    // Fires once, the first time the grid actually has items - objectIDs
    // here is static per page load, so there's nothing to re-fire a view for.
    let viewedEventSent = false;

    search.addWidgets([
        instantsearch.widgets.relatedProducts({
            container: '#js-relatedProducts',
            objectIDs: [cbpidValue],
            // Makes Recommend return a queryID, which the connector stamps onto
            // each item as __queryID (alongside a 1-based __position). Without it
            // Algolia can't attribute clicks/conversions to the Related Products model.
            queryParameters: { clickAnalytics: true },
            cssClasses: {
                // Bootstrap grid classes render this as a static responsive card
                // grid (same approach algolia-search-custom.js's hits widget uses
                // for the /browse grid) instead of a carousel. list-unstyled/mb-0
                // strip the default <ol> markers/margin - Product.cshtml doesn't
                // load instantsearch.css's reset theme (unlike /browse), so those
                // are still required here.
                list: ['row', 'px-0', 'list-unstyled', 'mb-4'],
                item: ['col-6', 'col-sm-4', 'col-xxl-3', 'd-flex', 'py-0', 'mb-4'],
            },
            templates: {
                // The page already has its own "Related Products" heading above
                // this widget - suppress the widget's built-in one.
                header: () => '',
                empty: () => '',
                item(recommendation, { html }) {
                    const slug = recommendation.slug || `${recommendation.name}_${recommendation.coBrandProductId}`;
                    return html`
                        <div class="card flex-grow-1 rounded-0">
                            <div class="align-self-center px-2 pt-3">
                                <a
                                    href="/products/${slug}"
                                    aria-label="${recommendation.name}"
                                    class="text-decoration-none"
                                    data-algolia-objectid="${recommendation.objectID}"
                                    onClick="${() => {
                        const queryID = recommendation.__queryID;
                        try {
                            if (queryID) {
                                window.aa('clickedObjectIDsAfterSearch', {
                                    index: indexName,
                                    eventName: 'Related Product Clicked',
                                    objectIDs: [recommendation.objectID],
                                    queryID,
                                    positions: [recommendation.__position || 1],
                                    url: window.location.href,
                                });
                            } else {
                                window.aa('clickedObjectIDs', {
                                    index: indexName,
                                    eventName: 'Related Product Clicked',
                                    objectIDs: [recommendation.objectID],
                                    url: window.location.href,
                                });
                            }
                        } catch {}

                        // Store attribution so the destination page's add-to-cart (and
                        // later cart/purchase) send convertedObjectIDsAfterSearch - same
                        // map and shape algolia-search-custom.js writes for /browse hits.
                        // Skipped without a queryID so an existing search attribution for
                        // this product isn't overwritten with an empty one.
                        if (queryID) {
                            try {
                                const attribMap = JSON.parse(sessionStorage.getItem('algolia_attrib_map') || '{}');
                                attribMap[recommendation.objectID] = {
                                    index: indexName,
                                    objectID: recommendation.objectID,
                                    queryID,
                                    position: recommendation.__position || null
                                };
                                sessionStorage.setItem('algolia_attrib_map', JSON.stringify(attribMap));
                            } catch {}
                        }
                    }}"
                                >
                                    <picture>
                                        <source data-srcset="${recommendation.imageUrl240P}" media="(max-width: 575.98px)" type="image/webp" />
                                        <source data-srcset="${recommendation.imageUrl300P}" media="(min-width: 576px)" type="image/webp" />
                                        <source data-srcset="${recommendation.imageUrl240J}" media="(max-width: 575.98px)" type="image/jpeg" />
                                        <source data-srcset="${recommendation.imageUrl300J}" media="(min-width: 576px)" type="image/jpeg" />
                                        <img class="card-img-top img-fluid lazyload" height="240" width="240" src="${recommendation.imageUrl300J}" alt="${recommendation.name}" />
                                    </picture>
                                    <p class="card-title mt-3 text-center fw-light">
                                        <strong>${recommendation.name}</strong>
                                    </p>
                                </a>
                            </div>
                        </div>
                    `;
                },
            },
        })
    ]);

    search.on('render', function () {
        const hasItems = document.querySelectorAll('#js-relatedProducts .ais-RelatedProducts-item').length > 0;
        if (relatedProductsSection) {
            relatedProductsSection.classList.toggle('d-none', !hasItems);
        }

        if (hasItems && !viewedEventSent && typeof window.aa === 'function') {
            viewedEventSent = true;
            // Algolia's Insights API rejects an event with more than 20 objectIDs
            // (this grid can render more than that) - same cap
            // algolia-search-custom.js's hits-viewed tracking already uses.
            const objectIDs = Array.from(
                document.querySelectorAll('#js-relatedProducts [data-algolia-objectid]')
            ).map(function (el) { return el.dataset.algoliaObjectid; }).slice(0, 20);

            try {
                window.aa('viewedObjectIDs', {
                    index: indexName,
                    eventName: 'Related Products Viewed',
                    objectIDs,
                    url: window.location.href,
                });
            } catch {}
        }
    });

    search.on('error', function () {
        // Recommend/search request failed (e.g. Algolia Recommend "Index does not
        // exist" 404 when the index has no Related Products model configured).
        // Registering this listener also prevents InstantSearch's internal
        // EventEmitter from re-throwing the error as an unhandled promise
        // rejection - see algolia-search-custom.js's error safety net for the
        // same pattern on /browse.
        relatedProductsSection?.classList.add('d-none');
    });

    search.start();
});